import React from 'react';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import { TextInput, DateInput, NumberInput, SelectInput } from 'components/input';

import {
  DisabledInputOptions, InputOptions,
} from 'util/constants';

import * as urls from './urls';
import * as utils from './utils';

export const BannerEdit = (props) => (
  <Edit editBackendPath={urls.bannerEditBackendPath}{...props}>
    <SimpleForm>
      <TextInput
        source='description'
        label='Description'
        options={DisabledInputOptions}
      />
      <TextInput
        source='redirect_url'
        label='Redirect URL'
        options={DisabledInputOptions}
      />
      <NumberInput
        source='priority'
        label='Priority'
        isRequired={true}
        options={InputOptions}
      />
      <DateInput
        source='valid_from'
        label='Valid From'
        isRequired={true}
        options={InputOptions}
      />
      <DateInput
        source='valid_to'
        label='Valid To'
        isRequired={true}
        options={InputOptions}
      />
      <SelectInput
        source='status'
        label='Status'
        choices={utils.BANNER_STATUS_CHOICES}
        isRequired={true}
        options={InputOptions}
      />
    </SimpleForm>
  </Edit>
);


// WEBPACK FOOTER //
// ./src/routes/news/BannerEdit.js